export enum EoiHttpMessageErrors {
  ONLY_CUSTOMERS_CAN_SUBMIT_EOI = "Only customer can submit EOI",
}
